BrowseParsedParamsHelper = require '../../../browse/frontend/helpers/parsed_params'

module.exports = DealsSearchParamsHelper =
  getBaseParams: (options={}) ->
    params = initializeParams(options)

    params.division = Cookie.get('division')
    params.facet_group_filters = getFacetGroupFiltersParam(options)
    params.isRefinementBarDisplayed = true if Groupon.RefinementBar?.isLeftBarVisible
    params.isLocalPage = Groupon.isLocalPage
    params.isSeoEnabled = Groupon.isSeoEnabled
    params.collectionType = Groupon.collection?.type
    params.category ?= 'all'

    _.extend params, BrowseParsedParamsHelper.getParsedParams() if Groupon.isSeoEnabled

    delete params.query if options.omitSearch

    params.query = Groupon.collection.id if params.collectionType
    params

initializeParams = (options) ->
  return _.clone(options.params) if options.params?

  parsedParams = Groupon.Utils.unparam()
  return unfilteredParams(parsedParams) if options.unfiltered

  parsedParams

unfilteredParams = (params) ->
  _.pick params, 'page', 'sort'

getFacetGroupFiltersParam = (options) ->
  if options.facet_group_filters?
    options.facet_group_filters
  else if not Groupon.refinementUiPageData
    if Groupon.inRAPI
      'topcategory|category|subcategory|subcategory2,deal_type'
    else
      'topcategory|category|category2|category3;deal_type;city|neighborhood'
